<script setup>

import {computed, nextTick, ref, watch, defineExpose} from "vue";
import {useToast} from "primevue/usetoast";
import Dialog from "primevue/dialog";
import Button from "primevue/button";
import FormBroker from "./FormBroker.vue";
import { trans } from 'laravel-vue-i18n';
const formData = ref()
const model = ref()
const modal = ref(false);
const loading = ref(false);
const toast = useToast();
const route = useRoute();
const params = computed(() => {
  return route.params
})

const identify = (model, type, id, callback) => {
  useUpkeep().identify(model).then((result) => {
    loading.value = true;
    let lFormData = null;
    let lModel = {};
    if (result) {
      lFormData = result.columns
      lFormData.forEach((el, fieldId) => {
        if(!(el.hideOn && el.hideOn.includes(type))) {
          el.children.forEach((q, index) => {
            if(q.hideOn && q.hideOn.includes(type))
              el.children.splice(index, 1);
          })
        } else {
          lFormData.splice(fieldId, 1);
        }
      })
      if(type === 'create') {
        loading.value = false;
        lFormData.forEach((el) => {
          el.children.forEach((q) => {
            if (q.defaultValue)
            {
              lModel[q.id] = q.defaultValue
            }
          })
        });

        callback({
          formData: lFormData,
          model: lModel
        })
      } else {
        read(id, model, (result) => {
          lModel = result;
          nextTick();
          loading.value = false;
          callback({
            formData: lFormData,
            model: lModel
          })
        })
      }
    }
  });
}
const read = (id, model, callback) => {
  loading.value = true;
  useUpkeep().read(id, model).then((result) => {
    loading.value = false;
    callback(result);
  });
}
const modalType = ref();
const modalParent = ref();
const modalThrough = ref();
const modalObj = ref();
const modalChild = ref();
const bindingAdd = (childModel, childBinding, parentModel, parentId, throughModel) => {
  modalType.value = 'bindingAdd';
  modalChild.value = {
    childBinding: childBinding,
    childModel: childModel,
  }
  modalThrough.value = throughModel;
  modalParent.value = {
    parentId: parentId,
    parentModel: parentModel,
  }
  identify(childModel, 'create', null, (obj) => {
    modalObj.value = obj;
    modal.value = true;
  })
}

const modalSave = () => {
  useUpkeep().create(modalChild.value.childModel, modalObj.value.model).then((result) => {
    toast.add({ severity: result.success ? 'info': 'danger', summary: trans('common.record_create'), detail: result.message, life: 3000 });
    nextTick()
    useUpkeep().attach(modalParent.value.parentModel, modalParent.value.parentId, modalChild.value.childModel, modalChild.value.childBinding, result.data, modalThrough.value).then(()=> {
      read(route.params.id, params.value.model, (data) => {
        model.value = data;
      })
    })
  })
}

const save = (__callback = null) => {
  if(route.meta.type === 'create') {
    useUpkeep().create(route.params.model, model.value).then((result) => {
      toast.add({ severity: result.success ? 'info': 'danger', summary: trans('common.record_create'), detail: result.message, life: 3000 });
      nextTick()
      if(__callback)
        __callback();
    })
  } else {
    useUpkeep().update(route.params.id, route.params.model, model.value).then((result) => {
      toast.add({ severity: result.success ? 'info': 'danger', summary: trans('common.record_edit'), detail: result.message, life: 3000 });
      nextTick()
      if(__callback)
        __callback();
    })
  }
}


watch(params, () => {
  identify(
      params.value.model,
      route.meta.type,
      route.params.id,
      (obj) => {
        formData.value = obj.formData;
        model.value = obj.model;
      });
}, {deep: true, immediate: true})

defineExpose({
  save
});
</script>

<template>
  <form-broker v-if="formData" :model-id="$route.params.model" :form-data="formData" :loading="loading" v-model="model" @on-binding-add="bindingAdd"></form-broker>
  <Dialog v-model:visible="modal" modal header="Edit Profile" :style="{ width: '80%' }">
    <form-broker v-if="modalObj && modalObj.formData" :form-data="modalObj.formData" :loading="loading" v-model="modalObj.model"></form-broker>
    <template #footer>
      <Button :label="$t('common.cancel')" severity="secondary" @click="modal = false" autofocus />
      <Button :label="$t('common.save')" severity="primary" @click="() => {
        modal = false;
        modalSave()
      }" autofocus />
    </template>
  </Dialog>
</template>

<style scoped lang="scss">

</style>
